import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component.tsx";
import "@/index.css"; // Importing the CSS file first
import { SocketProvider } from "@/services/Socket/socketContext.tsx";
import i18next from "i18next";
import LogRocket from "logrocket";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n";
import { getUserLanguage } from "./utils/utils.util.ts";

function setLanguage() {
  const lsLang = getUserLanguage();
  i18next.changeLanguage(lsLang);
}

function initLogRocket() {
  const environment = import.meta.env.VITE_ENVIRONMENT;
  if (!environment || environment !== "prod") {
    console.warn(
      "LogRocket is not initialized in non-production environments."
    );
    return;
  }

  const logRocketAppId = import.meta.env.VITE_LOG_ROCKET;
  if (!logRocketAppId) {
    console.error(
      "LogRocket is not initialized because VITE_LOG_ROCKET is not set."
    );
    return;
  }

  LogRocket.init(import.meta.env.VITE_LOG_ROCKET);
}

setLanguage();
initLogRocket();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <SocketProvider>
      <StrictMode>
        <App />
      </StrictMode>
    </SocketProvider>
  </ErrorBoundary>
);
